import axiosInstance from "./axiosInstance";

// POST /api/accounts/profiles/{profileId}/follow/
export const followUser = async (profileId) => {
  const response = await axiosInstance.post(
    `/accounts/profiles/${profileId}/follow/`
  );
  return response.data;
};

// POST /api/accounts/profiles/{profileId}/unfollow/
export const unfollowUser = async (profileId) => {
  const response = await axiosInstance.post(
    `/accounts/profiles/${profileId}/unfollow/`
  );
  return response.data;
};

// GET /api/accounts/profiles/{profileId}/ — is_following check
export const checkFollowStatus = async (profileId) => {
  const response = await axiosInstance.get(
    `/accounts/profiles/${profileId}/`
  );
  return { isFollowing: response.data.is_following };
};